module.exports = __webpack_public_path__ + "fonts/Roboto-Medium.9a3bf7a.woff";